import {
  observable, action, makeObservable, computed, runInAction,
} from 'mobx';
import to from 'await-to';
import Cookie from 'js-cookie';
import client from 'utils/graphql';
import set from 'lodash/set';

import login from 'graphql/mutations/login.gql';
import me from 'graphql/queries/me.gql';
import LostPasswordMutation from 'graphql/mutations/lostPassword.gql';
import ResetPasswordMutation from 'graphql/mutations/resetPassword.gql';

export default class Authentication {
  static storeName = 'Authentication';

  client = null;

  token = null;

  loggedInUser = null;

  constructor(context) {
    makeObservable(this, {
      loggedInUser: observable,
      isLoggedIn: computed,
      login: action.bound,
      logout: action.bound,
      resetPassword: action.bound,
      requestPasswordResetLink: action.bound,
    });
    Object.assign(this, context);

    this.client = client(this.token);
  }

  get isLoggedIn() {
    if (this.loggedInUser !== null && this.loggedInUser !== undefined) {
      return true;
    }

    const token = Cookie.get('auth_token');

    if (this.token || token) {
      if (!this.token && token) {
        this.token = token;
      }

      return this.me();
    }

    return false;
  }

  async login(credentials) {
    const query = login.loc.source.body;
    const [error, result] = await to(this.client.mutation(query, credentials));

    if (error) {
      return error;
    }

    const { token, user } = result.loginDashboard;

    await this.setLogin(user, token);

    return null;
  }

  logout() {
    this.loggedInUser = null;
    Cookie.remove('auth_token');
  }

  async me() {
    const query = me.loc.source.body;
    const [error, response] = await to(this.client.query(query));

    if (error) {
      this.logout();

      return false;
    }

    await this.setLogin(response.me.user);

    return true;
  }

  async setLogin(user, token = null) {
    runInAction(() => {
      set(this, 'loggedInUser', {
        name: user.billingName || `${user.lastName} ${user.firstName}`,
        ...user,
      });
    });

    if (token) {
      Cookie.set('auth_token', token);
    }
  }

  async requestPasswordResetLink(credentials) {
    const mutation = LostPasswordMutation.loc.source.body;
    const [error] = await to(this.client.mutation(mutation, { ...credentials, site: 'partner' }));

    return {
      error,
    };
  }

  async resetPassword(credentials) {
    const {
      email, token, password, password_confirmation,
    } = credentials;

    if (password !== password_confirmation) {
      return {
        loginData: {},
        error: 'Két jelszó nem egyezik meg',
      };
    }

    const mutation = ResetPasswordMutation.loc.source.body;
    const [error, result] = await to(this.client.mutation(mutation, {
      data: {
        email, token, password,
      },
    }));

    if (!error) {
      const loginData = result.resetPassword;
      await this.setLogin(loginData.user, loginData.token);
    }

    return {
      error,
    };
  }
}
